import React, { useEffect, useState } from "react";
import Star from "../../../../images/star.svg";
import DeleteIcon from "../../../../images/deleteIcon.svg";
import { getAllAppointmentByID, getSelectedPatient, deleteAppointment } from "../../../../Utils/localStore";
import { LuExternalLink } from "react-icons/lu";

const Appointments = ({ details, notify, eventDone, apts }) => {
  const [userID, setUserId] = useState(details.localID)
  const [currentApmt, setCurrentApmt] = useState(null)
  const [showDeleteDialog, setShowDeleteDialog] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const upcomingAppointments = [
    {
      localID: 1,
      title: "Checkup",
      department: "Radiology",
      appt_type: "Virtual Meeting",
      personnel: "Dr. Usman Dan Fodio",
      description: "Scheduled for Monday 17 May, 2023 at 12:00 PM WAT",
      date: 'Friday 17 May, 2024'
    },
    {
      localID: 2,
      title: "Appointment",
      department: "Therapy",
      appt_type: "In Person",
      personnel: "Dr. Ruth Magdalene",
      description: "Scheduled for Monday 17 May, 2023 at 12:00 PM WAT",
      date: 'Friday 17 May, 2024'
    },
    {
      localID: 3,
      title: "4 months scan",
      department: "Gynaecology",
      appt_type: "In person",
      personnel: "Dr. Michael Akinfenwa",
      description: "Scheduled for Monday 17 May, 2023 at 12:00 PM WAT",
      date: 'Friday 17 May, 2024'
    },
    {
      localID: 4,
      title: "Wound dressing",
      department: "Accident & Trauma",
      appt_type: "In person",
      personnel: "Nurse Titi Akinfenwa",
      description: "Scheduled for Monday 17 May, 2023 at 12:00 PM WAT",
      date: 'Friday 17 May, 2024'
    },
  ];
  const [events, setEvents] = useState([])

  const pastAppointments = [
    {
      localID: 1,
      title: "Appointment",
      department: "Therapuetics",
      appt_type: "In person",
      personnel: "Dr. Syslvester Sylvanus",
      description: "Scheduled for Monday 17 May, 2023 at 12:00 PM WAT",
      date: 'Friday 17 May, 2024'
    },
    {
      localID: 2,
      title: "Appointment",
      department: "Pharmacy",
      appt_type: "In person",
      personnel: "Pharm. Nengi Ugo",
      description: "Scheduled for Monday 17 May, 2023 at 12:00 PM WAT",
      date: 'Friday 17 May, 2024'
    },
    {
      localID: 3,
      title: "Appointment",
      department: "Neurology",
      appt_type: "In person",
      personnel: "Dr. Bolatito Abdulwahab",
      description: "Scheduled for Monday 17 May, 2023 at 12:00 PM WAT",
      date: 'Friday 17 May, 2024'
    },
    {
      localID: 4,
      title: "Appointment",
      department: "Surgery",
      appt_type: "In person",
      personnel: "Surgeon Akeem Douglas",
      description: "Scheduled for Monday 17 May, 2023 at 12:00 PM WAT",
      date: 'Friday 17 May, 2024'
    },
  ];

  const handleGetAllAppointments = async () => {
    setIsLoading(true)
    if (!userID) {
      await getSelectedPatient().then(resp => {
        setUserId(resp[0].localID)
      })
    }
    await getAllAppointmentByID(details?.localID)
      .then(resp => {
        setEvents(resp)
      })
    setIsLoading(false)
  }
  const handleAptDelete = async () => {
    if (currentApmt) {
      await deleteAppointment(currentApmt.localID)
        .then(resp => {
          notify.success('Record deleted successfully', { position: notify.POSITION.TOP_CENTER })
        })
      eventDone()
      setShowDeleteDialog(false)
    } else {
      notify.error('Something seems wrong', { position: notify.POSITION.TOP_CENTER })
    }
  }

  useEffect(() => {
    handleGetAllAppointments()
    return () => ''
  }, [])

  return (
    <>

      {
        showDeleteDialog &&
        <dialog >
          <div className="w-[300px] bg-white rounded-md p-8 border">
            <p className="text-center mb-6">Are you sure you want to delete this appointment?</p>
            <div className="flex justify-between">
              <button onClick={(e) => {
                e.preventDefault()
                handleAptDelete()
              }} className="rounded-md text-white bg-primary p-2">
                Confirm
              </button>
              <button autoFocus className="p-2 border rounded border-red-400" onClick={(e) => {
                e.preventDefault()
                setShowDeleteDialog(false)
              }}>
                Cancel
              </button>
            </div>
          </div>
        </dialog>}
      <section className="w-full font-euclid-circular-a pr-12">
        <div className="flex justify-between items-center gap-16">
          <div className="w-[200px] h-0 border  border-stone-600 border-opacity-50" />
          <p className="text-stone-600 text-opacity-50 text-sm font-normal leading-[21px]">
            Upcoming
          </p>
          <div className="w-[200px] h-0 border  border-stone-600 border-opacity-50" />
        </div>

        {/* Cards */}
        {
          apts && apts.length ?
            apts.map((item) => (
              <div
                key={item.localID}
                className="border-4 border-l-sky-500 border-t-0 border-b-0 border-r-0 pl-5 pt-3 mb-3"
              >
                <div className="flex flex-col gap-3">
                  <h2 className="text-gray-600 text-lg font-semibold leading-7">
                    {item.title}
                  </h2>
                  <div className="flex lg:justify-between flex-col lg:flex-row justify-start items-center gap-2 w-full">
                    <p className="lg:flex items-center gap-2 lg:w-4/6 w-full">
                      <img src={Star} alt="" />
                      <span className="text-gray-600 text-sm font-semibold leading-tight">
                        {item?.departments && item.departments.map((el, index) => {
                          return (
                            <span key={index + `tag`}> {el?.tag},</span>
                          )
                        })}
                        {item.department}{" "}
                      </span>
                    </p>
                    <p className="lg:w-2/6 w-full">
                      •
                      <span className="mx-3">{item.appt_type}</span>{" "}
                      •
                      <span > {item.personnel}</span>
                    </p>
                    <div className="flex gap-5">
                      {/* <div className="flex-col">
                        <button onClick={handleClick(item)}>
                          <LuExternalLink size={25} className="opacity-90" strokeWidth={1} />
                          <p>View </p>
                        </button>
                      </div> */}
                      <div className="flex-col lg:justify-items-center justify-start">
                        <button onClick={() => { setCurrentApmt(item); setShowDeleteDialog(true) }}>
                          <img src={DeleteIcon} alt="" className="m-auto" />
                          <p>Delete</p>
                        </button>
                      </div>
                    </div>
                  </div>
                  <p>{item.description}</p>
                </div>
              </div>
            ))
            :
            <p className="w-full text-center italic my-60 opacity-50">
              No Record to display
            </p>}

        <div className="flex justify-between items-center gap-16">
          <div className="w-[200px] h-0 border  border-stone-600 border-opacity-50" />
          <p className="text-stone-600 text-opacity-50 text-sm font-normal leading-[21px]">
            Past
          </p>
          <div className="w-[200px] h-0 border  border-stone-600 border-opacity-50" />
        </div>

        {/* {pastAppointments.map((item) => (
          <div
            key={item.localID}
            className="border-4 border-l-sky-500 border-t-0 border-b-0 border-r-0 pl-5 pt-3 mb-3"
          >
            <div className="flex flex-col gap-3">
              <h2 className="text-gray-600 text-lg font-semibold leading-7">
                {item.title}
              </h2>
              <div className="flex justify-between items-center pr-2 w-full">
                <p className="flex items-center gap-2">
                  <img src={Star} alt="" />
                  <span className="text-gray-600 text-sm font-semibold leading-tight">
                    {item.department}{" "}
                  </span>
                  <svg
                    width="4"
                    height="4"
                    viewBox="0 0 4 4"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="2" cy="2" r="2" fill="#4B5B65" />
                  </svg>{" "}
                  <span>{item.appt_type}</span>{" "}
                  <svg
                    width="4"
                    height="4"
                    viewBox="0 0 4 4"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="2" cy="2" r="2" fill="#4B5B65" />
                  </svg>{" "}
                  <span>{item.personnel}</span>
                </p>
                <div className="flex gap-5">
                  <div className="flex-col">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M21 9.00001L21 3.00001M21 3.00001H15M21 3.00001L12 12M10 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V14"
                        stroke="#4B4B4B"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <p className="text-center">View</p>
                  </div>
                  <div className="flex-col">
                    <img src={DeleteIcon} alt="" />
                    <p className="text-center">Delete</p>
                  </div>
                </div>
              </div>
              <p>{item.description}</p>
            </div>
          </div>
        ))} */}
      </section>
    </>
  );
};

export default Appointments;
